module.exports = __webpack_public_path__ + "img/couples-019.66071efc.jpg";